import { render, staticRenderFns } from "./ChipGeoTable.vue?vue&type=template&id=cb4f1ea2&"
import script from "./ChipGeoTable.vue?vue&type=script&lang=js&"
export * from "./ChipGeoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.10_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports